module.exports = __webpack_public_path__ + "static/media/1_cipla.e2a141a1.svg";